export default __webpack_public_path__ + "static/media/close-circle.0e7288d4.svg";